






















import Vue from 'vue';

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'error',
    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
    popperClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localShow: false,
    };
  },
  mounted() {
    this.localShow = this.show;
  },
  watch: {
    show(val) {
      this.localShow = val;
    },
  },
});
